import Pulse from "src/Component/Pulse";
import "./index.sass";
import Config from "src/Constants/Config";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";

interface MovieListProps {
  size?: string;
  title?: string;
  data: MovieType[];
  className?: string;
  showGradient?: boolean;
  showProvider?: boolean;
  handleOnClickPulse?: () => void;
  scrollTo?: number;
  selectedImage?: { image: string; hex: string; border: string };
}

const MovieList = ({
  size = "normal",
  title,
  data,
  className = "",
  handleOnClickPulse = () => {},
  showGradient = false,
  showProvider = false,
  scrollTo,
  selectedImage,
}: MovieListProps) => {
  const moviesRef = useRef<HTMLDivElement | null>(null);
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  useEffect(() => {
    if (scrollTo !== undefined && moviesRef.current) {
      moviesRef.current.scrollTo({
        left: scrollTo,
        behavior: "smooth",
      });
    }
  }, [scrollTo]);

  return (
    <div className={`movie-list ${size} ${className} ${showGradient ? "box-gradien" : ""}`}>
      {title && <div className="title">{title}</div>}
      <div className="movies" ref={moviesRef}>
        {data.map((item: MovieType, index: number) => {
          return (
            <div className="movie" key={`mov_${index}_${size}_${item.id}`} onClick={item.pulse ? handleOnClickPulse : () => {}}>
              {item.pulse && (
                <div className="movie-pulse" onClick={handleOnClickPulse}>
                  <Pulse />
                </div>
              )}
              <img
                style={{
                  borderColor:
                    item.activeBorder && selectedImage && selectedImage.border
                      ? selectedImage.border
                      : item.activeBorder && currentPage === 8
                      ? "#007CC3"
                      : "transparent",
                }}
                className={`${item.pulse || item.activeBorder ? "active" : ""}`}
                src={item.image}
                alt=""
              />
              {showProvider && item.provider && (
                <img
                  style={{
                    position: "absolute",
                    zIndex: 0,
                    top: 0,
                    left: 0,
                  }}
                  src={`${Config.BASE_URL}/images/provider/${item.provider}.png`}
                  alt=""
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MovieList;
